import React, { useContext } from 'react';
import Navbar from '../../../pages/Shared/Navber/Navbar';
import { Link, Outlet } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthProvider';
import useAdmin from '../../../hooks/useAdmin';

const DashBoardLayout = () => {
    const { user } = useContext(AuthContext);
    const [isAdmin] = useAdmin(user.email)

    return (
        <div>
            <Navbar></Navbar>


            <div className="drawer drawer-mobile">
                <input id="dashboard-drawer" type="checkbox" className="drawer-toggle" />
                <div className="drawer-content ">
                    <Outlet></Outlet>


                </div>
                <div className="drawer-side">
                    <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
                    <ul className="menu p-4 w-80 bg-base-100 text-base-content">

                        <li><Link to='/dashboard'>My Appointment</Link></li>
                        {
                            isAdmin && <>
                            <li><Link to='/dashboard/allusers'>All User</Link></li>
                            <li><Link to='/dashboard/addoctor'>Add A Doctor</Link></li>
                            <li><Link to='/dashboard/mnagedoctors'>Manage doctors</Link></li>
                            </>
                        }
                        <li><Link to='/'>Home</Link></li>
                    </ul>

                </div>
            </div>


        </div>
    );
};

export default DashBoardLayout;